//@ts-check

module.exports = (fox) => {

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'proceed': fox.i18n.getTranslation('proceed', 'Proceed', 'dialog'),
				'cancel': fox.i18n.getTranslation('cancel', 'Cancel', 'dialog'),
				'secretTitle': fox.i18n.getTranslation('secretTitle', 'Enter secret password', 'dialog'),
				};
			return translation[alias] || '';
		}
	};

	fox.registerWidget('Security_Popup_Setup', {
		configure: function () {
			this.registerOptions('', {
				contentTemplate: 'popup_security_setup',
				onOkPress: (...args) => this.setupPass(...args),
				dialog:{
					buttons: [{
						text: 'Proceed',
						click: function () {},
						class: 'button-with-spinner mc-btn btn-small btn-casual white',
						id: 'on-success'
					},{
						text: 'Cancel',
						click: function () {},
						class: 'mc-btn btn-small btn-minor',
						id: 'on-cancel'
					}
				],
				},
				
				widgets: {
					form: {
						formSelector: '#request-pass',
						validateOnFly: true,
						elements: {
							password:{
								womContainer: '@parent #content',
								validators: [
									v => {
										return {
											result: !!v.match(/(?=.*[0-9])(?=.*[!@#$%^&*\-+=_?.,:;()\[\]\{\}~><])(?=.*[a-z])(?=.*[A-Z]).*/g) && v.length <= 16 && v.length >= 8,
											message: v
										}
									}
								]
							}
						}
					}, 
					sendApi :{
						widget: 'Api',
						method: 'sc.model.setPassword',
						httpMethod: 'post'
					},
					content: {
						handleDom:{
							cleanError: {
								target: 'input',
								event: 'focus',
								callback: () => {
									const errBlock = document.querySelector('.errorApiSec');
									errBlock.style.display = 'none';
								},
							},
						}
					}
				},
			
				handleWom: {
					formInvaliadate: {
						widget: '#form',
						event: ['form_not_valid', 'form_valid'],
						callback: 'formInvalidate'
					},
					apiHandle: {
						event: ['error', 'failure'],
						widget: '#sendApi',
						callback: (err) => {
							const errBlock = document.querySelector('.errorApiSec');
							errBlock.textContent = err.answer.reason;
							errBlock.style.display = 'block';
						},
					},
				}
			});
			this.callParent('configure', arguments);
		},

		setupPass(elt) {
			let form = this.wom1('#form');
			let securityData = this.getParent();
			let sendApi = this.wom1('#sendApi');

			this.disableButton(elt);

			return form.submit().then(values => {
				if (values) { 
					if (values.password != values.confirm) {
						this.showError({field: 'confirm', message: 'Passwords must be equal'});
						this.enableButton();
						return false;
					} else {
						for (let i in values) {
							values[i] = encodeURIComponent(values[i]);
						}
						values.hash = this.getOption('schash');
						sendApi.psend(values).then(res => {
							this.onCancel();
							securityData.popupRequest.show();
						});
					}
					
				} else {
					this.enableButton();
					return false;
				}
			}).catch((err) => {
				this.enableButton();
				console.log(err);
			});
		},

		formInvalidate(res){
			let fields = res.map(field => {
				//if (field.result === true) return [];
				let error = [];
				if (!field.message) {
					field.message = '';
					let msg = fox.dom.selectFirst(`[name=${field.field}]`).validationMessage;
					this.showError({field: field.field, message: msg});
				}
				if (field.field != 'confirm') {
					error['charcount'] = field.result || (field.message.length >= 8 && field.message.length <= 16);
					error['lettercase'] = field.result || /(?=.*[a-z])(?=.*[A-Z])[a-zA-Z]{1,}/g.test(field.message);
					error['numbers'] = field.result || /(?=.*[0-9])[0-9]{1,}/g.test(field.message);
					error['specialchar'] = field.result || /(?=.*[!@#$%^&*\-+=_?.,:;()\[\]\{\}~><])/g.test(field.message);
				}
				return error;
			})

			fields.every((field) => {
				Object.keys(field).forEach((key) => {
					let action = field[key] ? 'add' : 'remove';
					let elt = this.dom1(`.${key}`);
					elt.classList[action]('done');
				});
			})

		}

	}, 'Popup_Form');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/widget/setupPopup.es.js